import React, { useState, useEffect } from "react";
import { StepProps } from "../../../config/types";

interface Step9Props extends StepProps {
  setStepValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const Step9: React.FC<Step9Props> = ({
  handleChange,
  formValues,
  setStepValid,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(
    formValues
      .q9_have_you_taken_any_prescription_medications_to_lose_weight_before?.[0] ||
      null
  );
  const [medicationDetails, setMedicationDetails] = useState<string>(
    formValues.q9_prescription_medications_to_lose_weight_before?.[0] || ""
  );

  useEffect(() => {
    const isStepValid =
      selectedOption !== null &&
      (selectedOption === "Yes" ? medicationDetails.trim() !== "" : true);
    setStepValid(isStepValid);

    if (selectedOption) {
      handleChange({
        target: {
          name: "q9_have_you_taken_any_prescription_medications_to_lose_weight_before",
          value: [selectedOption],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }

    if (selectedOption === "Yes" && medicationDetails.trim() !== "") {
      handleChange({
        target: {
          name: "q9_prescription_medications_to_lose_weight_before",
          value: [medicationDetails],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  }, [selectedOption, medicationDetails, setStepValid]);

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
    if (value !== "Yes") {
      setMedicationDetails("");
      handleChange({
        target: {
          name: "q9_prescription_medications_to_lose_weight_before",
          value: [""],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const handleMedicationDetailsChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setMedicationDetails(e.target.value);
  };

  return (
    <div className="min-h-[50vh] lg:px-[50px] px-[0px] ">
      <p className="text-[#000000] text-[18px] font-[400] text-left mb-5">
        9. Have you taken any prescription medications to lose weight before?
      </p>
      <div className="flex flex-row gap-[20px] items-center my-3 mb-7">
        <button
          type="button"
          onClick={() => handleOptionChange("Yes")}
          className={`min-h-[45px] rounded-[5px] min-w-[102px] border border-[#3B82F6] ${
            selectedOption === "Yes"
              ? "bg-[#3B82F6] text-white"
              : "text-[#000000] bg-[#ffffff]"
          }`}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => handleOptionChange("No")}
          className={`min-h-[45px] rounded-[5px] min-w-[102px] border border-[#3B82F6] ${
            selectedOption === "No"
              ? "bg-[#3B82F6] text-white"
              : "text-[#000000] bg-[#ffffff]"
          }`}
        >
          No
        </button>
      </div>

      {selectedOption === "Yes" && (
        <div className="mt-4">
          <p className="text-[#000000] text-[18px] font-[400] text-left">
            Please provide us with the date range, name, dose, and frequency of
            the prescription medications taken for weight loss
          </p>
          <textarea
            name="q9_prescription_medications_to_lose_weight_before"
            value={medicationDetails}
            onChange={handleMedicationDetailsChange}
            className="w-full p-2 border border-gray-300 rounded mt-2"
            rows={5}
            placeholder="Please specify if any"
          />
        </div>
      )}
    </div>
  );
};

export default Step9;
